export default "__VITE_ASSET__BhIgXaYm__"